export enum SheetCustomScales {
  SCALE_AUTO = "SCALE_AUTO",
  SCALE_1_16 = "SCALE_1_16",
  SCALE_1_8 = "SCALE_1_8",
  SCALE_1_4 = "SCALE_1_4",
  SCALE_1_2 = "SCALE_1_2",
}
